import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Formik, Form } from 'formik';

import ServiceForm from './forms/service';
import EndorsementForm from './forms/endorsement';
import PatientForm from './forms/patient';
import SubscriberForm from './forms/subscriber';
import { useLoadingBar } from '../../libraries/contexts';
import { SUBSCRIPTOR_RESULT_PATH } from '../../routers/subscriptor';
import SuscriptorService from '../../services/request-service';
import UserService from '../../services/user-service';

import { SUBSCRIPTOR_OK_BUTTON, SERVER_ERROR } from '../../libraries/texts';
import { LIMIT_SHOW_CEDULA } from '../../libraries/constants';
import {
  isRequired,
  isMultiplesSelectorsRequired,
  isValidAvalForm,
  isValidSubscriptorForm,
  isValidServiceForm,
  isValidPatientForm,
  removeErrors,
  unTouch
} from '../../libraries/validators';
import { add as styles } from './styles';

const AddSubscriptorForm = props => {
  const { classes, history } = props;
  const [errorMessageServer, setErrorMessageServer] = useState('');
  const [, setLoading] = useLoadingBar();
  const initialValues = {
    amount: 0,
    rut: UserService.getCurrentUser().rut,
    budgetAmount: 0,
    patientSuscriptorCb: false,
    patientOncologicalAgreementCb: false,
    patientComplementaryInsuranceCB: false,
    allowEndorsement: false,
    isavalNormalized: true,
    issuscriptorNormalized: true,
    services: [{ key: 0 }],
    suscriptorMessage: '',
    avalMessage: '',
    suscriptorStatus: 5,
    avalStatus: 5
  };
  const onSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading({ principalLoading: true });

      const data = await SuscriptorService.post(values);
      const url = SUBSCRIPTOR_RESULT_PATH.replace(':id', data._id);
      setLoading({ principalLoading: false });
      history.push(url);
    } catch (err) {
      setLoading({ principalLoading: false });
      const { errors } = await err;
      if (errors && errors.length > 0) {
        setErrorMessageServer(errors.join(', '));
      } else {
        setErrorMessageServer(SERVER_ERROR);
      }
    }
  };

  const getErrors = values => {
    const errors = {};
    const {
      budgetAmount,
      services,
      guaranteeType,
      medicalRisk,
      suscriptorDni,
      suscriptorRegion,
      suscriptorCommune,
      suscriptorAddress,
      suscriptorAddressNumber,
      suscriptorCapturedFingerprint,
      suscriptorEmail,
      suscriptorTel1,
      suscriptorTel2,
      avalDni,
      avalRegion,
      avalCommune,
      avalAddress,
      avalAddressNumber,
      avalEmail,
      avalTel1,
      avalCapturedFingerprint,
      avalTel2,
      allowEndorsement,
      patientDni,
      patientInsurance
    } = values;
    const serviceRequired = {
      medicalRisk,
      guaranteeType,
      budgetAmount
    };
    const SubscriptorRequired = {
      suscriptorDni,
      suscriptorRegion,
      suscriptorCommune,
      suscriptorAddress,
      suscriptorAddressNumber,
      suscriptorEmail,
      suscriptorTel1,
      suscriptorTel2,
      suscriptorCapturedFingerprint
    };

    const EndorsementRequired = {
      avalDni,
      avalRegion,
      avalCommune,
      avalAddress,
      avalAddressNumber,
      avalCapturedFingerprint,
      avalEmail,
      avalTel1,
      avalTel2
    };

    const patientRequired = {
      patientDni,
      patientInsurance
    };

    if (values.suscriptorDni >= LIMIT_SHOW_CEDULA) {
      delete SubscriptorRequired.suscriptorCapturedFingerprint;
    }
    if (values.allowEndorsement && avalDni >= LIMIT_SHOW_CEDULA) {
      delete EndorsementRequired.avalCapturedFingerprint;
    }
    isRequired(errors, { ...serviceRequired, ...SubscriptorRequired, ...patientRequired });

    isMultiplesSelectorsRequired(errors, { services });

    isValidServiceForm(errors, values);

    isValidSubscriptorForm(errors, values);

    isValidPatientForm(errors, values);

    if (allowEndorsement) {
      isRequired(errors, EndorsementRequired);
      isValidAvalForm(errors, values);
    } else {
      removeErrors(errors, EndorsementRequired, 'aval');
    }
    return errors;
  };

  const isValidForm = (errors, touched) =>
    Object.values(errors).length === 0 && Object.values(touched).length !== 0;

  return (
    <React.Fragment>
      <Card className={classes.card}>
        <Formik initialValues={initialValues} validate={getErrors} onSubmit={onSubmit}>
          {props => {
            const {
              values: { allowEndorsement },
              errors,
              touched
            } = props;

            if (!allowEndorsement) {
              unTouch(touched, 'aval');
            }
            return (
              <React.Fragment>
                <Form className={classes.formSubscriptor}>
                  <ServiceForm {...props} />
                  <SubscriberForm {...props} />
                  <Collapse
                    timeout={800}
                    in={allowEndorsement}
                    className={classes.collapseContainer}
                  >
                    {allowEndorsement ? <EndorsementForm {...props} /> : ''}
                  </Collapse>

                  <PatientForm {...props} />
                  <CardActions className={classes.actions} disableActionSpacing>
                    <Button
                      color="primary"
                      variant="contained"
                      type="submit"
                      disabled={!isValidForm(errors, touched)}
                    >
                      {SUBSCRIPTOR_OK_BUTTON}
                    </Button>
                  </CardActions>
                  {errorMessageServer.length > 0 ? (
                    <Typography gutterBottom>{errorMessageServer}</Typography>
                  ) : (
                    ''
                  )}
                </Form>
              </React.Fragment>
            );
          }}
        </Formik>
      </Card>
    </React.Fragment>
  );
};

AddSubscriptorForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AddSubscriptorForm);
